
export const strings = {
    cutLongDescription(str) {
        const subString = str.slice(0, 46); // the original check
        return str.length > 46 ? subString.slice(0, subString.lastIndexOf(" ")) : str
    },
}